import API from './api';

export default {
  getRecoveredCustomers() {
    return API.get('/api/users/me/recovered-customers');
  },
  getDelinquentCustomers() {
    return API.get('/api/delinquent-customers/me');
  },
  getExpiringCards() {
    return API.get('/api/subscription-payment-cards/me');
  },
  /* Customers Modal */
  getCoupons() {
    return API.get('/api/coupons');
  },
  /** @deprecated / @unused */
  createCoupon(payload) {
    return API.post('/api/coupons', payload);
  },
  editSubscription(subscriptionId, payload) {
    return API.put(`/api/subscriptions/${subscriptionId}`, payload);
  },
  editSubscriptionItem(ids, payload) {
    const { subscriptionId, itemId } = ids;
    return API.put(`/api/subscriptions/${subscriptionId}/item/${itemId}`, payload);
  },
};
